import { Shop } from "./shop.model";

export class DatafoxDevice {
  public serialNumber: string;
  public name: string;
  public shop: Shop;
  public deviceType: string;
  public status: TerminalStatus;
  public firmwareVersion: string;
}

export enum TerminalStatus {
  Unknown = 0,
  Online = 1,
  Offline = 2,
  Wait = 3
}
